import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import styled from "@emotion/styled";
import { RootState, i18n, sendOffersToEmail, useAppSelector } from "src/common";
import { Flex, Label, Text, Button } from 'src/components';
import { colors } from "src/theme";
import { Card } from "./card";

const TextStyle = styled(Text)({
  color: colors.text2,
  textWrap: 'initial'
})

interface SendOffersToEmailCardProps {
  className?: string;
}

export const SendOffersToEmailCard = ({ className }: SendOffersToEmailCardProps) => {
  const { birthDate, email, phoneNumber} = useAppSelector((store: RootState) => store.model.customer.data);

  const [isSendOffersDisabled, setIsSendOffersDisabled] = useState(false);
  const [sendOffersToEmailMutation] = useMutation(sendOffersToEmail);

  const sendOffers = () => {
    sendOffersToEmailMutation({
      variables: { birthDate, email, phoneNumber }
    });
    setIsSendOffersDisabled(true);
  }

  return (
    <Card radius={12} padding={16} className={className}>
      <Flex vertical gap={12}>
        <Label type='small'>{i18n.t('components.cards.SendOffersToEmailCard.notSure')}</Label>
        <Button style={{ backgroundColor: colors.success2, borderColor: colors.success2 }} onClick={sendOffers} disabled={isSendOffersDisabled}>
          <TextStyle type="base" bold>{i18n.t(`components.cards.SendOffersToEmailCard.${isSendOffersDisabled ? 'sendOffersDisabled' : 'sendOffers'}`)}</TextStyle>
        </Button>
      </Flex>
    </Card>
  )
};


